import styled from 'styled-components';

const Message = styled.span`
  align-items: center;
  display: flex;

  strong {
    font-weight: bold;
  }
`;

export { Message };

